/** Every name the app accepts for a unit, by the unit it writes. */
const UNIT_ALIASES: Record<string, string> = {
    gr: "gr",
    gram: "gr",
    grams: "gr",
    kg: "kg",
    kilogram: "kg",
    kilograms: "kg",
    lt: "lt",
    litre: "lt",
    litres: "lt",
    ml: "ml",
    millilitre: "ml",
    millilitres: "ml",
    qt: "qt",
    quart: "qt",
    quarts: "qt",
};

/** The density of Jet A-1, the one the app converts between litres and kilograms with. */
export const JET_A1_KG_PER_LITRE = 0.79;

/** A quantity in another unit as the app converts it: only litres and kilograms convert, any other is left as it is. */
export function convertFluid(value: number, from: string, to: string): number {
    if (from === "lt" && to === "kg") return value * JET_A1_KG_PER_LITRE;
    if (from === "kg" && to === "lt") return value / JET_A1_KG_PER_LITRE;
    return value;
}

/** Litres in a quantity; null for a unit that is neither litres nor kilograms. */
export function litresOf(value: number, unit: string): number | null {
    return unit === "lt" || unit === "kg" ? convertFluid(value, unit, "lt") : null;
}

export function unitOf(text: string | null): string | null {
    return UNIT_ALIASES[(text ?? "").replace(/[^a-zA-Z]/g, "").toLowerCase()] ?? null;
}

/** The first number, with a comma or a dot, and the unit from the letters, as the app reads a quantity. */
export function quantityOf(text: string | null): { value: number | null; unit: string | null } {
    if (!text?.trim()) return { value: null, unit: null };
    const number = /([0-9]+([.,][0-9]+)?)/.exec(text);
    return { value: number ? Number(number[1].replace(",", ".")) : null, unit: unitOf(text) };
}

/** The organization's units, and any unit a row of the flight already has, so a value keeps its own. */
export function unitsWith(units: string[], present: (string | null)[]): string[] {
    return [...new Set([...units, ...present.filter((unit): unit is string => !!unit)])];
}
